var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 56,
    viewBox: "0 0 62 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.5133 4.72998H1.79618C0.80407 4.72998 0 5.45016 0 6.33877V48.9658C0 49.8544 0.80407 50.5746 1.79618 50.5746H59.5133C60.5055 50.5746 61.3095 49.8544 61.3095 48.9658V6.33877C61.3095 5.45016 60.5055 4.72998 59.5133 4.72998Z",
    fill: "#9DB1C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6548 4.72998H1.79618C0.80407 4.72998 0 5.45016 0 6.33877V48.9658C0 49.8544 0.80407 50.5746 1.79618 50.5746H30.6548V4.72998Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 41.3418V48.9659C0 49.8545 0.80407 50.5747 1.79618 50.5747H59.5133C60.5055 50.5747 61.3095 49.8545 61.3095 48.9659V41.3418H0ZM9.72696 47.3572H3.59236V44.556H9.72696V47.3572ZM19.3463 47.3572H13.3193V44.556H19.3463V47.3572ZM28.9657 47.3572H22.9387V44.556H28.9657V47.3572ZM38.5855 47.3572H32.5581V44.556H38.5855V47.3572ZM48.2049 47.3572H42.1779V44.556H48.2049V47.3572ZM57.7172 47.3572H51.7973V44.556H57.7172V47.3572Z",
    fill: "#29353D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3095 13.9667V6.33877C61.3095 5.45058 60.5055 4.72998 59.5133 4.72998H1.79618C0.80407 4.72998 0 5.45058 0 6.33877V13.9667H61.3095ZM51.7973 7.94756H57.7172V10.7487H51.7973V7.94756ZM42.1779 7.94756H48.2049V10.7487H42.1779V7.94756ZM32.5581 7.94756H38.5855V10.7487H32.5581V7.94756ZM22.9387 7.94756H28.9657V10.7487H22.9387V7.94756ZM13.3193 7.94756H19.3463V10.7487H13.3193V7.94756ZM3.59236 7.94756H9.72696V10.7487H3.59236V7.94756Z",
    fill: "#29353D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6548 41.3418H0V48.9659C0 49.8545 0.80407 50.5747 1.79618 50.5747H30.6548V41.3418ZM9.72696 47.3572H3.59236V44.556H9.72696V47.3572ZM19.3463 47.3572H13.3193V44.556H19.3463V47.3572ZM22.9387 47.3572V44.556H28.9657V47.3572H22.9387Z",
    fill: "#638094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6548 4.72998H1.79618C0.80407 4.72998 0 5.45016 0 6.33877V13.9667H30.6548V4.72998ZM9.72696 10.7487H3.59236V7.94756H9.72696V10.7487ZM19.3463 10.7487H13.3193V7.94756H19.3463V10.7487ZM22.9387 10.7487V7.94756H28.9657V10.7487H22.9387Z",
    fill: "#638094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2964 25.995C37.2478 25.9632 37.1968 25.9334 37.1444 25.9062L26.8669 20.5327C26.1222 20.0966 25.1437 20.0471 24.3391 20.4141C23.5468 20.7748 23.0547 21.4791 23.0547 22.2517V33.0536C23.0547 33.8261 23.5468 34.53 24.3391 34.8911C24.6993 35.0553 25.0946 35.1362 25.4879 35.1362C25.973 35.1362 26.4557 35.0134 26.8669 34.7721L37.1444 29.399C37.1968 29.3718 37.2478 29.3421 37.2964 29.3102C37.904 28.9135 38.253 28.3098 38.253 27.6528C38.253 26.9959 37.904 26.3914 37.2964 25.995Z",
    fill: "#5E55E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6538 22.5129L26.8669 20.5329C26.1222 20.0964 25.1437 20.0473 24.3391 20.4139C23.5468 20.7751 23.0547 21.4793 23.0547 22.2519V33.0534C23.0547 33.8259 23.5468 34.5302 24.3391 34.8913C24.6993 35.0555 25.0946 35.1364 25.4879 35.1364C25.973 35.1364 26.4557 35.0132 26.8669 34.7723L30.6538 32.7928V22.5129Z",
    fill: "#9690F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61.3095,
    height: 54.9133,
    fill: "white",
    transform: "translate(0 0.225586)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilm);
export default __webpack_public_path__ + "static/media/film.1661b0cca7e1d0e5865d2869e325d557.svg";
export { ForwardRef as ReactComponent };